export default __webpack_public_path__ + "static/media/Amar.12eb7edd.jpg";